export const useGetSingaColor = () => (id: number): string => {
	const colors = [
		'#DC6556',
		'#12B961',
		'#BB9A11',
		'#97857B',
		'#FFFFFF',
		'#5A50AF',
		'#4D4D4D',
		'#A93223',
		'#74F1AF',
		'#EECD44',
		'#F5EBDC',
		'#B2B2B2',
		'#AFA4D7',
		'#757575'
	]
	return colors[id % colors.length]
}

export const useMakeId = async () => {
	const getRandomValues = (length: number) => {
		const array = new Uint8Array(length)
		crypto.getRandomValues(array)
		return array
	}

	const uuid = ([1e7] as any + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c: string) =>
		(Number(c) ^ getRandomValues(1)[0] & 15 >> (Number(c) / 4)).toString(16)
	)

	// Convert the UUID to ArrayBuffer
	const encoder = new TextEncoder()
	const uuidArrayBuffer = encoder.encode(uuid)

	// Calculate SHA-1 hash using Web Crypto API
	const hashBuffer = await crypto.subtle.digest('SHA-1', uuidArrayBuffer)

	// Convert the hash to a hex string
	const hashArray = Array.from(new Uint8Array(hashBuffer))
	const hash = hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('')

	return hash
}

export const useTruncate = (title: string, limit = 50) => {
	if (title.length > limit) {
		return title.slice(0, limit) + '…'
	}
	return title
}

export const useGetOS = () => {
	const { isIos, isWindows, isMacOS, isAndroid } = useDevice()
	let os = 'Unknown'

	if (isIos) {
		os = 'iOS'
	}
	if (isWindows) {
		os = 'Windows'
	}
	if (isMacOS) {
		os = 'MacOS'
	}
	if (isAndroid) {
		os = 'Android'
	}
	return os
}

export const createMetadescription = (songs: Array<Song>, length = 160) => {
	const metaDescriptionSongList: string[] = []
	for (let i = 0; i < songs.length; i++) {
		const { getAllArtists } = useArtistNames(songs[i].artists)
		const artists = getAllArtists()
		metaDescriptionSongList.push(
			`${i + 1}. ${artists} – ${songs[i].name}`
		)
	}
	const metaDescription = useTruncate(metaDescriptionSongList.join(', '), length)
	return metaDescription
}

export const consoleLogSingaLogo = () => {
	const singaText = `
	%c░░░░░░░░░░░%c▒▓██████▓%c░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░
	░░░%c▒█▓▒%c░░%c▓██▓%c░░░░░░%c█▓%c░░░%c▒██▒%c░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░
	░░░░%c█▒%c░░%c▓██▒%c░░░░░%c░▒▓%c░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░
	░░░░░%c▒▒▒███▓▓▒▒▒▒▒%c░░░░░%c██▓%c░░%c▒██%c░%c▒███▒%c░░░░%c▓███▓██%c░░░░%c▒▓██▓▓█▓%c
	░░░░░░░░░%c▓████▓%c░░░░░░░%c███%c░░%c▒██▓▓████▒%c░░%c▓██▒%c░%c▒██▓%c░░%c▒██▓%c░░%c███%c▒
	░░░░░░░░░░░%c▒▓████%c░░░%c░███%c░░%c▒██▓▓▒▒██▒%c░░%c██▓%c░░░%c███%c░░%c▓██▒%c░░%c▒██%c▒░
	░%c▒███▓▒%c░░░░░░░%c▓███▒%c░%c▓██%c░░░%c███▒%c░%c▒██▒%c░░%c██▓%c░░░%c▓██%c░░%c▓██%c░░░%c▒██▒%c░░
	%c▓█▓%c░░░░░░░░░░░░%c███▓▒██▓%c░░%c▓██▒%c░░%c██▒%c░░%c███%c░░░%c▓██%c░░%c▒██▒%c░░%c▒██▓%c░░░%c
	██%c░░░░░░░░░░░░%c▒███%c░%c███%c░░%c▓██▒%c░░%c██▓%c░%c░▓██▒%c░%c▒▓██▒%c░░%c███%c░░%c▓▓██%c░░▒░
	░%c█▓%c░░░░░░░░░░%c▓██▓%c░░%c███▓▒▒██%c░░░%c███▓▓▒████▒███▒▓▒▓███▓%c░%c▓██▓▒%c░░
	░░%c▒▓▓▒▒▒▒▓▓▓▓▓▒%c░░░░░░░░░░░░░░░░░░░░░░░░%c▒███▒%c░░░░░░░░░░░░░░░░
	░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░%c▓▓███%c░░░░░░░░░░░░░░░░░░
	░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░%c█▓███%c░░░░░░░░░░░░░░░░░░░
	`
	return console.log(singaText, 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent', 'color: #17E87A', 'color: transparent')
}
